import { routerReducer } from 'react-router-redux';
import { configureStore, combineReducers } from '@reduxjs/toolkit';

import { apiSlice } from './apiSlice';
import appReducer, {
  setCheckToken,
  setToken,
  setUser,
} from 'modules/app/appSlice';
import templatesReducer from 'modules/templates/templatesSlice';
import dashboardReducer from 'modules/dashboard/dashboardSlice';
import analyticsReducer from 'modules/analytics/analyticsSlice';
import notificationsReducer from 'modules/notifications/notificationsSlice';

const appReducers = combineReducers({
  app: appReducer,
  templates: templatesReducer,
  router: routerReducer,
  dashboard: dashboardReducer,
  analytics: analyticsReducer,
  notifications: notificationsReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export const store = configureStore({
  reducer: appReducers,
  middleware: getdefaultMiddleware =>
    getdefaultMiddleware({
      serializableCheck: false,
    }).concat([
      apiSlice.middleware,
      // store => next => action => {
      //   console.log('Action:', action); // Logs all actions, including RTK Query actions
      //   return next(action);
      // },
    ]),
});

// Check full redux state
// console.log('Full Redux state:', store.getState());

// Auto-fetch and store data when the app starts
store.dispatch(apiSlice.endpoints.checkToken.initiate()).then(({ data }) => {
  if (data) {
    store.dispatch(setToken(data.token)); // Store fetched token
    store.dispatch(setUser(data.user)); // Store fetched user data
  }
  store.dispatch(setCheckToken(true)); // Store token check status
});

//routerMiddleWare.listenForReplays(store);
/*
  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers');
      store.replaceReducer(nextReducer);
    })
  }
*/
